"use client";

import { dataLayer } from "@repo/analytics/data-layer-utils"; // Adjust if dataLayer is elsewhere
import {
  componentNameConstants,
  dlElementConstants,
  dlEventConstants,
  dlCtaTextConstants,
} from "@repo/analytics/data-layer.constants";

/**
 * Triggers data layer event for the Info Icon click in the Stock Fundamentals section.
 * @param sectionTitle - The title of the section where the icon was clicked.
 */
export const handleInfoIconDL = (loginStatus: string, sectionTitle: string) => {
  const data = {
    section_title: sectionTitle,
    component: componentNameConstants.STOCK_FUNDAMENTALS,
    event: dlEventConstants.CLICK,
    event_type: dlEventConstants.ICON_CLICK,
    cta_text: dlElementConstants.OPEN_ICON,
    element: dlElementConstants.INFO_ICON,
  };

  const cleverTapObj = {
    EVENT_NAME: dlElementConstants.PDP_CLICKED,
    EP_ARTICLE_NAME: dlElementConstants.FUNDAMENTALS,
  };

  dataLayer(loginStatus, data, cleverTapObj);
};

/**
 * Triggers data layer event when the close icon or button is clicked in Stock Fundamentals section.
 * @param sectionTitle - The title of the section where the event happened.
 * @param ctaText - The CTA label to send.
 * @param btnClick - If true, indicates a button click; otherwise, an icon click.
 */
export const handleCloseBtnDL = (
  loginStatus: string,
  sectionTitle: string,
  ctaText: string,
  btnClick = false,
) => {
  const data = {
    section_title: sectionTitle,
    component: componentNameConstants.STOCK_FUNDAMENTALS,
    event: dlEventConstants.CLICK,
    event_type: btnClick
      ? dlEventConstants.BUTTON_CLICK
      : dlEventConstants.ICON_CLICK,
    element: btnClick
      ? dlElementConstants.STOCK_FUNDAMENTALS_BTN_CLICK
      : dlElementConstants.STOCK_FUNDAMENTALS_ICON_CLICK,
    cta_text: ctaText,
  };

  const cleverTapObj = {
    EVENT_NAME: dlElementConstants.PDP_CLICKED,
    EP_ARTICLE_NAME: dlElementConstants.FUNDAMENTALS,
    EP_CTA: dlCtaTextConstants.CLOSE_ICON,
  };

  dataLayer(loginStatus, data, cleverTapObj);
};
